import { render, staticRenderFns } from "./CustomActionsReport.vue?vue&type=template&id=67335fba&"
import script from "./CustomActionsReport.vue?vue&type=script&lang=ts&"
export * from "./CustomActionsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports